import { SetState } from 'zustand';
import type { InventorizeMeterStore } from '../../useStore';

const INITIAL_STATE: MapStepForm = {
  lat: undefined,
  lng: undefined,
};

export interface MapStepForm {
  lat?: number;
  lng?: number;
}

export type MapStepSlice = MapStepForm & {
  resetMapStepSlice: () => void;
  setMapStepValues: (values: MapStepForm) => void;
};

export const createMapStepSlice = (set: SetState<InventorizeMeterStore>): MapStepSlice => ({
  ...INITIAL_STATE,
  resetMapStepSlice: () => set(INITIAL_STATE),
  setMapStepValues: (values: MapStepForm) => set(values),
});
